import { ConditionViewerItem, ConditionViewerTerm } from '@customerio/pluma-components/react';
import type { InboundNode } from '../../types';
import { getIconForNode } from '../data-source-icon';
import { FilterDetailList, FiltersLeadIn, hasFilters, Times, Within } from '../condition-parts';

type InboundConditionProps = { node: InboundNode };

export function InboundCondition({ node }: InboundConditionProps) {
  const operator = node.inverse ? 'not received' : 'received';
  return (
    <ConditionViewerItem
      icon={getIconForNode(node)}
      details={hasFilters(node.filters) ? <FilterDetailList filters={node.filters} /> : undefined}
    >
      <ConditionViewerTerm>Inbound SMS</ConditionViewerTerm> {operator}
      <Times times={node.times} />
      <Within within={node.within} />
      <FiltersLeadIn filters={node.filters} filtersOperator={node.filtersOperator} />
    </ConditionViewerItem>
  );
}
